var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.31 94.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#00a193;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.21.5c26.4,0,38.72,22.74,38.72,46.56s-12.32,46.7-38.72,46.7S.5,70.89.5,47.06,12.82.5,39.21.5Zm0,20.57c-10.83,0-15.16,10-15.16,26s4.33,26.13,15.16,26.13S54.37,63,54.37,47.06,50,21.07,39.21,21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.55,31.63,95.39,46.93,82.12,33,113.66,1.85h20.17V92.14H110.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.09,68.32A12.72,12.72,0,1,1,147.37,81,12.88,12.88,0,0,1,160.09,68.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.bc832fbd5d43f71482e6fd03a411b1b2.svg";
export { ForwardRef as ReactComponent };